<template>
  <b-sidebar
    v-if="isOpenLocal"
    v-model="isOpenLocal"
    id="sidebar-right-bdr-dict"
    :title="editedItemLocal.id ? `Редактирование свойства #${editedItemLocal.id}` : 'Добавление свойства'"
    right
    backdrop
    shadow
    width="45em"
    backdrop-variant="dark"
    no-close-on-backdrop
  >
  <!-- @change="closeSidePanelCallback()" -->
    <div class="d-block">  
      <b-row class="my-2" style="align-items: center;">
        <b-col sm="3">
          <label for="input-name">Название</label>
        </b-col>
        <b-col sm="9">
          <b-form-input
              v-model="editedItemLocal.name"
              id="input-name"
              size="sm"
          />
        </b-col>
      </b-row>
      <b-row class="my-2" style="align-items: center;">
        <b-col sm="3">
          <label for="input-reference_id">Родитель</label>
        </b-col>
        <b-col sm="9">
            <b-form-select 
                v-model="editedItemLocal.parent_id" 
                :options="parentOptions"
                size="sm"
            ></b-form-select>
        </b-col>
      </b-row>
      <b-row class="my-2" style="align-items: center;">
        <b-col sm="3">
          <label for="input-unit">Признак</label>
        </b-col>
        <b-col sm="9">
          <b-form-select 
              v-model="editedItemLocal.unit" 
              :options="unitOptions"
              size="sm"
          ></b-form-select>
        </b-col>
      </b-row>
      <b-row class="my-2" style="align-items: center;">
        <b-col sm="3">
          <label for="input-external_number">Номер пункта (прим: 1.1.)</label>
        </b-col>
        <b-col sm="9">
          <b-form-input
              v-model="editedItemLocal.external_number"
              id="input-external_number"
              size="sm"
          />
        </b-col>
      </b-row>
      
      <div class="d-flex mt-2 mb-2">
        <b-button
            size="md"
            class="ml-auto btn btn-secondary"
            @click="closeSidebar()"
            :disabled="loading"
        >
            Отмена
        </b-button>
        <b-button
            size="md"
            class="ml-2 btn btn-primary"
            @click="saveElement()"
        >
            Сохранить <b-icon v-if="loading" icon="arrow-repeat" scale="1.2" aria-label="Reload" :animation="loading ? 'spin' : ''"></b-icon>
        </b-button>
      </div>
    </div>     
  </b-sidebar>   
</template>

<script>
import { API_BDR_DICTIONARY } from '@/constants';

const initialDictionaryElement = () => (
    {
      name: '',
      unit: 'B2C',
      external_number: '',
      parent_id: 0
    }
);

export default {
  name: 'BdrDictionarySidebar',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    editedItem: {
      type: Object,
      default: () => (
        {
          name: '',
          unit: 'B2C',
          external_number: '',
          parent_id: 0
        }
      ),
    },
  },
  components: {
  },
  // watch: {
  //   editedItem: {
  //       deep: true,
  //       handler(editedItem) {
  //         console.log("IN!", editedItem)
  //         console.log("isOpenLocal", this.isOpenLocal);
  //       },
  //   }, 
  // },  
  computed: {
    isOpenLocal: {
      get: function() {
        return this.isOpen
      },
      set: function(value) {
        this.$emit('update:isOpen', value)
      }
    },
    editedItemLocal: {
      get: function() {
        return this.editedItem
      },
      set: function(value) {
        // this.$emit('update:editedItem', value)
      }
    },      
  },  
  data() {
    return {
      loading: false,
      parentOptionsData: [],
      parentOptions: [],
      unitOptions: [
          {
              text: 'Танаис B2C',
              value: 'B2C'
          },
          {
              text: 'Танаис B2B',
              value: 'B2B'
          },
          {
              text: 'БСЗ',
              value: 'БСЗ'
          },
      ],      
    }
  },
  mounted() {
    this.getDictionary();
  },
  methods: {
    getDictionary() {
      axios.get(`${API_BDR_DICTIONARY}?easylist=true`).then(({ data }) => {
          this.parentOptionsData = data;
          this.formNestedParentOptions(this.parentOptionsData, 0, '')
          this.loading = false;
      });        
    },
    formNestedParentOptions(dictionary, parent_id, addsymb = '') {
        dictionary.forEach((reference, index) => {
            let addSmth = '';
            if (reference.external_number) {
                addSmth = `, ${reference.external_number}`
            }
            this.parentOptions.push({
                value: reference.id,
                text: `${addsymb}${reference.id}: ${reference.name} (${reference.unit}${addSmth})`
            });

            if (reference.children && reference.children.length > 0) {
                this.formNestedParentOptions(reference.children, reference.id, addsymb + '-');
            }
        })
    },

    closeSidebar() {
      this.isOpenLocal = false;
    },
    saveElement() {
      this.loading = true;
      if (this.editedItemLocal.id) {
        axios.put(`${API_BDR_DICTIONARY}/${this.editedItemLocal.id}`, this.editedItemLocal)
        .then(() => {
          this.$emit('updateItem', this.editedItemLocal);
          this.editedItemLocal = initialDictionaryElement();
          this.loading = false;
          this.closeSidebar();
        });
      } else {
        axios.post(`${API_BDR_DICTIONARY}`, this.editedItemLocal)
        .then(() => {
          this.$emit('updateItem');
          this.editedItemLocal = initialDictionaryElement();
          this.loading = false;
          this.closeSidebar();
        });
      }
    },    
  },  
}
</script>
